module.exports = __webpack_public_path__ + "static/media/learning-analytics-in-coding-lessons.b850c3ee.webp";